module.exports = __webpack_public_path__ + "img/Ancho_JeanFreddy.f8c2a897.png";